<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :hide-details="hideDetails"
    class="vcita-text-input"
    :readonly="readonly"
    :rules="rules"
    :class="{
      'number-type': type === 'number'
    }"
    color="rgba(0, 0, 0, 0.87)"
    :type="type"
    :value="value"
    :style="{
      color: `${brandBgColor} !important`
    }"
    :data-qa="dataQa"
    :step="step"
  >
    <template
    v-slot:append
    v-if="type === 'number'"
    >
      <v-layout
        class="number-counter"
        column>
        <v-btn
          class="counter-btn"
          :ripple="false"
          min-width="44px"
          max-height="25px"
          @click="updateValue(parseFloat(step))"
          icon>
          <v-icon class="cart-up-icon">
            icon-caret-down
          </v-icon>
        </v-btn>
        <v-btn
          @click="updateValue(-parseFloat(step))"
          class="counter-btn"
          :ripple="false"
          min-width="44px"
          max-height="25px"
          icon>
          <v-icon>
            icon-caret-down
          </v-icon>
        </v-btn>
      </v-layout>
    </template>
    <template #prepend-inner>
      <slot name="prepend-inner">
      </slot>
    </template>
    <slot>
    </slot>
  </v-text-field>
</template>

<script>
  export default {
    deprecated: "Please use VcTextField from the design system package",
    props: {
      dataQa: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: '',
      },
      step: {
        type: String,
        default: '1',
      },
      value: {
        required: true,
        default: ''
      },
      min: {
        type: String,
        default: '',
      },
      max: {
        type: String,
        default: '',
      },
      rules: {
        type: Array
      },
      hideDetails:{
        type: Boolean | String,
        default: "auto"
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      updateValue(num) {
        let currVal = parseFloat(this.value)
        if (this.step.length === 1)
          currVal = parseFloat((currVal + num));
        else currVal = parseFloat((currVal + num).toPrecision(this.step.length + 1))
        if( (this.min && currVal < parseFloat(this.min)) || (this.max && currVal > parseFloat(this.max)) ) {
          return;
        }
        this.$emit('input', currVal.toString())
      },
    },
    computed: {
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .text-input-container {
    font-family: var(--primary-font-family);
    position: relative;
  }
  .number-counter {
    @include i-border-left(1px solid rgba(0, 0, 0, 0.12));
  }
  .text-input-with-select {
    position: relative;
  }
  .item-text {
    font-family: var(--primary-font-family);
    font-weight: normal;
    letter-spacing: normal;
    text-transform: none;
    width: 100%;
  }
  .counter-btn {
    border-radius: 0;
    .cart-up-icon{
      transform: rotate(180deg);
    }
  }
</style>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .vcita-text-input.v-text-field {
    margin: 0;
    padding: 0;
    label {
      font-family: var(--primary-font-family);
      letter-spacing: -0.3px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.4);
    }
    .v-text-field__slot:first-child {
      margin: 0 12px;
    }
    &[prepend-inner-icon] {
      .v-text-field__slot {
        padding: 0;
      }
    }
    &.v-input--is-label-active, &.v-input--is-focused  {

      label {

        font-family: var(--primary-font-family);
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: -0.3px;
        color: rgba(0, 0, 0, 0.62) !important;
        transform: translateY(-100%) scale(0.85);
        top: 8px;
      }
    }
    &:not(.v-text-field--outlined) {
      .v-text-field__slot {
        transition: margin-bottom 0.1s;
      }
      &.v-input--is-label-active, &.v-input--is-focused {
        .v-text-field__slot {
          margin-bottom: -20px;
        }
      }
    }
    &.v-input--is-focused {
      .v-input__slot {
        border: 1px solid var(--brand-color-secondary) !important;
        box-shadow: 0 0 0 3px rgba(var(--brand-color-secondary-rgb), 0.4);
        z-index: 1;
      }
    }
    .v-input__slot {
      min-height: 52px !important;
      border-radius: 6px;
      background-color: #fff !important;
      position: relative !important;
      border: solid 1px rgba(0, 0, 0, 0.12);
      transition: border-color,background-color 0.1s !important;
      &:hover {
        border: 1px solid #757575;
      }
      &:before, &:after {
        display: none;
      }
    }
    &.v-input--is-disabled {
      .v-input__slot {
        background-color: rgba(0, 0, 0, 0.03) !important;
      }
    }
    input {
      font-family: var(--primary-font-family);
      font-size: 15px !important;
      font-weight: 500;

    }
    .v-text-field__prefix {
      color: rgba(0, 0, 0, 0.54) !important;
    }
    .v-input__prepend-inner, .v-input__append-inner {
      color: rgba(0, 0, 0, 0.4);
      margin: auto 12px auto 12px !important;
      max-width: 20px;
      max-height: 20px;
      padding: 0 !important;
      .v-input__icon {
        height: 100%;
        max-width: 100%;
        min-width: 100%;
        max-height: 100%;
        min-height: 100%;
      }
      i {
        color: rgba(0, 0, 0, 0.4);
      }
    }
    &.error--text {
      .v-input__slot {
        border: 1px solid #F2514A;
      }
      margin-bottom: 12px;
    }
    &.number-type {
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }
      .v-input__append-inner {
        margin: 0 !important;
        max-width: revert;
        max-height: revert;
      }
    }
  }
</style>
